<template>
  <div v-if="show" class="pw-overlay" @click.self="$emit('close')">
    <div class="pw-card">
      <button class="pw-close" @click="$emit('close')" aria-label="Fermer">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
      </button>

      <div class="pw-badge">
        <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path>
        </svg>
      </div>

      <span class="pw-eyebrow">Paiement confirmé</span>
      <h2 class="pw-title">Bienvenue en Pro 🎉</h2>
      <p class="pw-sub">Votre compte est maintenant <strong>Pro</strong>. Voici ce qui est débloqué :</p>

      <ul class="pw-features">
        <li v-for="(f, i) in features" :key="i">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="m9 12 2 2 4-4"></path></svg>
          <span>{{ f }}</span>
        </li>
      </ul>

      <button class="pw-cta" @click="$emit('close')">C'est parti</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProWelcomeModal',
  props: {
    show: { type: Boolean, default: false }
  },
  emits: ['close'],
  data() {
    return {
      features: [
        'Déploiement de votre agent sur WhatsApp et votre site',
        'Agents de test illimités',
        'Quota Moo 300 + Griot 1000 / mois (renouvelés chaque mois)',
        'Support communauté WhatsApp'
      ]
    };
  }
};
</script>

<style scoped>
.pw-overlay {
  position: fixed; inset: 0;
  background: rgba(10, 26, 20, 0.9);
  backdrop-filter: blur(8px);
  display: flex; align-items: center; justify-content: center;
  z-index: 10000; padding: 20px;
}
.pw-card {
  position: relative;
  background: #143028; color: #fff;
  border-radius: 2rem;
  width: 100%; max-width: 460px;
  padding: 2.5rem 2rem 2rem;
  text-align: center;
  box-shadow: 0 40px 100px -20px rgba(0,0,0,0.6);
  animation: pwReveal 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}
@keyframes pwReveal { from { opacity: 0; transform: translateY(24px) scale(0.97); } to { opacity: 1; transform: none; } }
.pw-close {
  position: absolute; top: 1rem; right: 1rem;
  background: none; border: none; color: rgba(255,255,255,0.6); cursor: pointer; padding: 4px;
}
.pw-close:hover { color: #fff; }
.pw-badge {
  width: 4.5rem; height: 4.5rem; margin: 0 auto 1.25rem;
  border-radius: 9999px; background: #DAFFD1; color: #143028;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 0 0 8px rgba(218, 255, 209, 0.12);
}
.pw-eyebrow {
  display: inline-block; font-size: 11px; font-weight: 900;
  text-transform: uppercase; letter-spacing: 0.18em;
  color: #DAFFD1; margin-bottom: 0.5rem;
}
.pw-title { font-size: 1.9rem; font-weight: 800; letter-spacing: -0.03em; margin: 0 0 0.6rem; }
.pw-sub { font-size: 0.95rem; line-height: 1.5; color: rgba(255,255,255,0.75); margin: 0 0 1.5rem; }
.pw-features { list-style: none; padding: 0; margin: 0 0 1.75rem; text-align: left; display: flex; flex-direction: column; gap: 0.7rem; }
.pw-features li { display: flex; align-items: flex-start; gap: 0.6rem; font-size: 0.9rem; line-height: 1.35; }
.pw-features svg { color: #DAFFD1; flex-shrink: 0; margin-top: 1px; }
.pw-cta {
  width: 100%; padding: 1rem;
  border-radius: 9999px; border: none; cursor: pointer;
  background: #DAFFD1; color: #143028;
  font-size: 0.85rem; font-weight: 800; letter-spacing: 0.05em;
  transition: transform 0.2s;
}
.pw-cta:hover { transform: scale(1.02); }
</style>
